import React from 'react';

import Requests from '../Requests/Requests';
import RouteParams from '../interfaces/RouteParams';
import Loading from '../Loading/Loading';
import AppRoot from '../AppRoot/AppRoot';
import NonAuthorized, { NonAuthorizedMode } from '../NonAuthorized/NonAuthorized';
import { HealthDecValidationOptions } from '../interfaces/HealthDecValidation';
import KeycloakWrapper from '../Keycloak/KeycloakWrapper';
import RouterParams from '../interfaces/RouteParams';
import { ProductSpecificData } from '../interfaces/ProductConfig';
import AppStorage from '../Storage/Storage';

interface ValidationWrapperState {
  status: HealthDecValidationOptions | undefined;
}

class ValidationWrapper
  extends React.PureComponent<RouterParams, ValidationWrapperState> {
  private readonly storage: AppStorage;

  constructor(props: RouteParams) {
    super(props);

    this.storage = AppStorage.getInstance();

    this.state = {
      status: undefined,
    };
  }

  async componentDidMount(): Promise<void> {
    await this.getPublicProductConfig();
    this.getHealthDeclarationStatus();
  }

  getHealthDeclarationStatus = (): void => {
    const { healthDeclarationId } = this.props;

    void Requests.getHealthDeclarationStatus(healthDeclarationId)
      .then((response) => {
        const status = response.data.result;
        this.setState({
          status,
        });
      });
  };

  getPublicProductConfig = () => {
    const id = window.location.pathname.split('/')[1];
    return Requests.getPublicProductConfig(id)
      .then((response) => {
        const { progressBarLabels, instructions, ...rest } = response.data.result;
        this.storage.setProductSpecificInfo(rest as ProductSpecificData);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render(): React.ReactElement {
    const {
      status,
    } = this.state;

    if (status === HealthDecValidationOptions.VALID) {
      return (
        <KeycloakWrapper>
          <AppRoot />
        </KeycloakWrapper>
      );
    }

    if (status === HealthDecValidationOptions.INVALID) {
      return (
        <NonAuthorized mode={NonAuthorizedMode.INVALID_QS} />
      );
    }

    if (status === HealthDecValidationOptions.MAINTENANCE) {
      return (
        <NonAuthorized mode={NonAuthorizedMode.MAINTENANCE} />
      );
    }

    return (
      <Loading />
    );
  }
}

export default ValidationWrapper;
